<template>
  <div class="input-invoice-scan">
    <input type="password" style="display: none" />
    <PgInput
      ref="refInput"
      type="password"
      class="input-invoice-scan--input"
      :class="{ 'area-scaninput': size === 'max' }"
      v-bind="$attrs"
      v-model="invoiceData.code"
      :placeholder="placeholder"
      prefix-icon="ivu-icon-icon-pg-scan1"
      :disabled="disabled || selfDisabled"
      clearable
      @keyup.native="parsing"
      @focus="onFocusEvent"
    />
    <PgInput
      type="text"
      ref="refInputText"
      :class="{ 'area-scaninput': size === 'max' }"
      v-bind="$attrs"
      v-model="invoiceData.code"
      clearable
      :placeholder="placeholder"
      prefix-icon="ivu-icon-icon-pg-scan1"
    />
  </div>
</template>

<script setup>
import { reactive, ref, nextTick, watch, onBeforeUnmount } from 'vue'
import { PgInput } from '../../input/index'
import { useInputInvoiceScan } from '../hooks/index.js'
import { useBeforValueOldActions } from '../../../hooks/index'

const emit = defineEmits(['on-scan', 'input', 'on-focus'])

const props = defineProps({
  placeholder: { type: String, default: '请先扫描能够识别的发票二维码' },
  // 扫码输入框大小,默认为较大的样式，配置其他值时与表单的输入框大小一致
  size: { type: String, default: 'max' },
  disabled: { type: Boolean, default: false },
  store: { type: Object },
  beforValueAction: {
    type: Object,
  },
})

const data = reactive({ code: '' })
const invoiceData = reactive({ code: '' })
const refInputText = ref(null)
const refInput = ref(null)
const selfDisabled = ref(false)
const changeDisabled = (val) => {
  selfDisabled.value = val
  if (!val) {
    nextTick(() => {
      refInput.value?.focus()
      refInput.value.select()
    })
  }
}

const { beforeEmit } = useBeforValueOldActions({
  store: props.store,
  beforValueAction: props.beforValueAction,
  emit,
})
const { parsing, clearInput } = useInputInvoiceScan({
  data,
  emit,
  beforeEmit,
  changeDisabled,
  invoiceData,
})
const onFocusEvent = () => {
  emit('on-focus')
}
onBeforeUnmount(() => {
  refInput.value.$el.children[0].children[0].value = ''
})
// 焦点移入至扫码输入框
const inputFocus = () => {
  nextTick(() => {
    refInput.value?.focus()
  })
}

// 加载完成时移入焦点
inputFocus()

// 外部可调用的方法
defineExpose({
  inputFocus,
  clearInput,
  select: () => {
    refInput.value?.select()
  },
})

// 测量元素宽度的函数
function measureWidth(element, type, value) {
  // 创建隐藏元素用于测量文本宽度
  const hiddenDiv = document.createElement('div')
  hiddenDiv.style.position = 'absolute'
  hiddenDiv.style.left = '-9999px'
  hiddenDiv.style.whiteSpace = 'nowrap'
  document.body.appendChild(hiddenDiv)
  // 获取元素的字体样式
  const computedStyle = window.getComputedStyle(element)
  hiddenDiv.style.font = computedStyle.font

  if (type === 'password') {
    // 密码框使用掩码字符
    hiddenDiv.textContent = '•'.repeat(value.length)
  } else {
    hiddenDiv.textContent = value
  }

  // #10340
  const offsetWidth = hiddenDiv.offsetWidth
  document.body.removeChild(hiddenDiv)

  return offsetWidth // hiddenDiv.offsetWidth
}
watch(
  () => invoiceData.code,
  (val) => {
    const textWidth = measureWidth(refInputText.value.$el, 'text', val ?? '')
    const passwordWidth = measureWidth(refInput.value.$el, 'password', val ?? '')
    const poor = textWidth - passwordWidth
    refInput.value.$el.children[0].children[0].style['letter-spacing'] =
      val.length > 1 ? `${poor / (val.length - 1)}px` : '0px'
  }
)
</script>

<style lang="scss">
@import '../style/input-invoice-scan.scss';
</style>
